import styled, { css } from 'styled-components';
import { smallSpacedHeading } from '../../../../theme/typography';
import { themeColor } from '../../../../theme/getters';
import { media } from '../../../../theme/media';

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 24px;
  grid-row-gap: 32px;

  ${media.tablet`
    grid-column-gap: 56px;
  `}
`;

const slotDefault = css`
  color: ${themeColor('primary')};
  border: 1px solid ${themeColor('border')};
`;

const slotSelected = css`
  background-color: ${themeColor('primary')};
  color: ${themeColor('white')};
  border: 1px solid ${themeColor('primary')};
`;

const slotDisabled = css`
  pointer-events: none;
  color: ${themeColor('border')};
  border: 1px solid ${themeColor('disabled')};
`;

export const Slot = styled.div`
  display: block;
  height: 56px;
  ${smallSpacedHeading};
  ${props => (props.isSelected ? slotSelected : slotDefault)};
  ${props => !props.isActive && slotDisabled};
  cursor: pointer;
  line-height: 56px;

  ${media.tablet`
    line-height: 56px;
  `}
`;
